import React from 'react';
import '../index.css';

const Home = () => (
  <div className="Home">
    <div>
      <h1 className="text-lg">Welcome to my page!</h1>
    </div>
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sunt dolore
      corrupti adipisci? Nemo delectus, excepturi doloribus nam sint fuga quasi
      atque debitis inventore amet nesciunt animi a asperiores et repudiandae!
    </p>
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sunt dolore
      corrupti adipisci? Nemo delectus, excepturi doloribus nam sint fuga quasi
      atque debitis inventore amet nesciunt animi a asperiores et repudiandae!
    </p>
  </div>
);
export default Home;
